import { DataHolderComponent } from "components/components/Component";
import { CancelConfirmation } from "components/confirmationDialog/cancelConfirmation";
import { Router } from "./router";

export class DiscardConfirmation {
    private changedDataHolders = {};
    private static sourcePath: string;
    private targetPath: string;
    constructor() {
        window.addEventListener("beforeunload", (e) => {
            if (this.isChanged()) {
                const confirmationMessage = "It looks like you have been editing something. "
                    + "If you leave before saving, your changes will be lost.";
                (e || window.event).returnValue = confirmationMessage; // Gecko + IE
                return confirmationMessage; // Gecko + Webkit, Safari, Chrome etc.
            }
        });
        window.addEventListener("unload", (e) => {
            this.firePageChangeEvent();
        });
        window.addEventListener("hashchange", (e: HashChangeEvent) => {
            if (this.isChanged()) {
                if (DiscardConfirmation.sourcePath !== e.newURL) {
                    this.targetPath = e.newURL;
                    window.location.href = e.oldURL;
                    DiscardConfirmation.sourcePath = e.oldURL;
                    new CancelConfirmation().confirmRoute(this.acceptCallbackRoute);
                } else {
                    Router.getInstance().resume();
                }
            } else {
                this.firePageChangeEvent();
                DiscardConfirmation.sourcePath = e.newURL;
                Router.getInstance().resume();
            }
        });

        window.addEventListener("askForChangeConfirmation", (e: CustomEvent) => {
            if (this.isChangedDataHolder(e.detail.componentHolder)) {
                new CancelConfirmation().confirmRoute(() => {
                    this.clearChangedDataHolder(e.detail.componentHolder);
                    e.detail.callback();
                });
            } else {
                e.detail.callback();
            }
        });

        window.addEventListener("popstate", (e: PopStateEvent) => {
            if (this.isChanged()) {
                Router.getInstance().pause();
            }
        });

        document.addEventListener("dataChanged", (e: CustomEvent) => {
            if (e.detail.component.definition.preventLoss !== false) {
                if (this.changedDataHolders[e.detail.component.definition.id] != true) {
                    console.log("change registered in discard confirmation manager", e);
                }
                this.changedDataHolders[e.detail.component.definition.id] = true;
            }
        });

        document.addEventListener("dataChangeCleared", (e: CustomEvent) => {
            delete this.changedDataHolders[e.detail.componentId];
        });
    }

    private acceptCallbackRoute = () => {
        this.firePageChangeEvent();
        this.clearChanged();
        window.location.href = this.targetPath;
    }

    public isChanged(): boolean {
        return Object.keys(this.changedDataHolders).length > 0;
    }

    public isChangedDataHolder(h: DataHolderComponent): boolean {
        if (h == null) {
            return false;
        }
        return this.changedDataHolders[h.definition.id] != null;
    }

    public clearChanged() {
        this.changedDataHolders = {};
    }

    public clearChangedDataHolder(h: DataHolderComponent) {
        delete this.changedDataHolders[h.definition.id];
    }

    private firePageChangeEvent() {
        document.dispatchEvent(new CustomEvent("embededPageToClose"));
    }
}
